import type { SxProps, Theme } from '@mui/material/styles';
import { tableResetSx } from '../../shared/utils/styles';

export const pricingTableContainerSx: SxProps<Theme> = {
  flex: '2 1 320px',
  alignSelf: 'start',
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: '8px',
  overflow: 'hidden',
};

export const pricingTableSx: SxProps<Theme> = [
  tableResetSx,
  {
    '& .MuiTableCell-root': { px: 2, py: 2 },
    '& .MuiTableCell-head': { fontWeight: 'fontWeightBold' },
    '& .MuiTableCell-alignRight': { whiteSpace: 'nowrap' },
    '& .MuiTableHead-root .MuiTableCell-root, & .MuiTableBody-root .MuiTableRow-root:not(:last-of-type) .MuiTableCell-root':
      {
        borderBottom: '1px solid',
        borderColor: 'divider',
      },
  },
];

export const feeSummarySx: SxProps<Theme> = {
  flex: '1 1 200px',
  py: 2,
  px: 3,
  backgroundColor: 'primary.light',
  border: '1px solid',
  borderColor: 'primary.border',
  borderRadius: '8px',
};

export const feeSummaryListSx: SxProps<Theme> = {
  m: 0,
  mt: 2,
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  '& dd:not(:last-of-type)': { mb: 1 },
};
